import { unitResource } from '@/views/insurance/underwritingManage/request';
import { filesList, delFiles, filesStatus } from './request';
import { COLUMNSLIST, TYPE } from './utils';
import filesModel from './filesModel.vue';
import informationModel from '@/views/template/components/informationModel';
export default {
  components: {
    filesModel,
    informationModel
  },
  data() {
    return {
      COLUMNS: COLUMNSLIST,
      informationShow: false,
      filesShow: false,
      form: {
        name: '',
        unitId: undefined,
        type: undefined
      },
      TYPE,
      tableData: [],
      unitList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    unitResource({}).then(res => {
      console.log(res);
      this.unitList = res;
    });
    this.getDataFun();
  },
  methods: {
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const {
        totalNum,
        items
      } = await filesList(obj);
      this.pagination.total = totalNum;
      this.tableData = items;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleAdd() {
      this.filesShow = true;
      this.$nextTick(() => {
        this.$refs.filesRef.init(false, this.unitList);
      });
    },
    handleEdit(val) {
      this.filesShow = true;
      val.documentId = val.id;
      this.$nextTick(() => {
        this.$refs.filesRef.init(val, this.unitList);
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该文件') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delFiles({
          documentId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getDataFun();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.reminderDocumentStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      filesStatus({
        documentId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        console.log(res);
        if (res.length == 0) {
          this.$message.success(this.$t('操作成功') + '!');
          this.getDataFun();
        } else {
          this.informationShow = true;
          this.$nextTick(() => {
            this.$refs.informationRef.init(res, 5);
          });
        }
      });
    }
  }
};